<!--
=========================================================================================
    Message Card Selector
==========================================================================================
-->

<template>
  <div v-if="type" id="communication-message-list" key="message-list-control">
    <transition-group name="list-enter-up" class="email__mails" tag="ul" appear>
      <component :is="type" :parent="'#communication-message-list'" :key="type" />
      <!-- <component :is="localData.panels[localData.selectedPanel]"
        :key="localData.panels[localData.selectedPanel] + '-list-panel'"
      /> -->
    </transition-group>
  </div>
  <div v-else>Nothing</div>
</template>

<script>
import { state } from "../data";

export default {
  components: {
    pm: () => import(`./PM/TopicList`),
    chat: () => import(`./Chat/MessageList`),
    webboard: () => import(`./Webboard/TopicList`),
  },
  data() {
    return {
      localData: state.local
    }
  },
  computed: {
    type() {
      return this.localData.currentViewingMessageType;
    },
  }
}
</script>
